import { DownOutlined } from '@ant-design/icons';
import { Button, Modal, Row, Col, Select } from 'antd';
import { getOptionInvoiceHeader } from 'pages/RegisterReceivingStatus/thunks';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import Wrap from './styles';

type Props = {
  facility_name: string;
  invoice_month: string;
  defaultOptionInvoice: any[];
  changeInvoiceMonth: any;
  loadHospital: any;
};

const ConsultationStatus: FC<Props> = ({
  facility_name,
  invoice_month,
  defaultOptionInvoice,
  changeInvoiceMonth,
  loadHospital,
}) => {
  const dispatch = useDispatch();
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const { optionH3, facility } = useSelector((state: RootState) => state.receivingSlice);
  useEffect(() => {
    if (facility?.i_id) {
      dispatch(getOptionInvoiceHeader({ facility_id: facility?.i_id }));
    }
  }, [facility?.i_id, dispatch]);
  const closeModal = () => {
    setModalVisible(false);
  };
  return (
    <Wrap>
      <span className="extraLargeFont">
        {facility_name} {invoice_month && `${invoice_month.slice(0, 4)}年${invoice_month.slice(4)}月度`}　受診状況
      </span>
      <Button onClick={() => setModalVisible(true)} className="btn-change-display-month standardBoldFont">
        過去の受診状況 <DownOutlined />
      </Button>
      <Modal
        visible={modalVisible}
        style={{ position: 'absolute', right: 40, top: '130px' }}
        width={378}
        bodyStyle={{ padding: '18px 17px' }}
        closable={false}
        okButtonProps={{ style: { display: 'none' } }}
        cancelButtonProps={{ style: { display: 'none' } }}
        footer={null}
        onCancel={() => setModalVisible(false)}
      >
        <Row justify="space-around">
          <Col span={15}>
            <Select style={{ width: '100%' }} value={invoice_month} onChange={changeInvoiceMonth}>
              {optionH3.length > 0
                ? optionH3.map((op) => (
                    <Select.Option value={op.value}>{op.name.slice(0, op.name.length - 1)}</Select.Option>
                  ))
                : defaultOptionInvoice.map((opd) => <Select.Option value={opd.value}>{opd.name}</Select.Option>)}
            </Select>
          </Col>
          <Col span={3}>
            <Button
              onClick={() => {
                closeModal();
                loadHospital();
              }}
              style={{
                backgroundColor: '#ff8a00',
                border: 'none',
                boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.25)',
                borderRadius: '5px',
                color: 'white',
              }}
            >
              表示
            </Button>
          </Col>
        </Row>
      </Modal>
    </Wrap>
  );
};

export default ConsultationStatus;
